import "@babel/polyfill";
import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import VModal from "vue-js-modal";
import store from "./store";
//import VueLodash from 'vue-lodash'
import "./plugins/axios";
import { BootstrapVue } from "bootstrap-vue";
import { VueReCaptcha } from "vue-recaptcha-v3";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";
import Echo from "laravel-echo";

/*
window.io = require('socket.io-client');
if(window.location.hostname.includes("localhost")){
  window.Echo = new Echo({
    broadcaster: 'socket.io',
    host: 'localhost:6001'
  });
}else{
  //web.meinelohnabrechnung.at
  window.Echo = new Echo({
    broadcaster: 'socket.io',
    host: window.location.hostname
  });
}
window.Echo.channel('test-event').listen('ExampleEvent', (e) => {
  console.log(e);
});
*/

Vue.config.productionTip = false;
Vue.use(VModal, { dialog: true });
Vue.use(BootstrapVue);
//Vue.use(VueLodash)
Vue.use(VueReCaptcha, {
  siteKey: "6LdK8IUUAAAAACoVDRzjCYhdJIm_hPFKhEiAgyYn",
  loaderOptions: {
    autoHideBadge: true,
  },
});

/* new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
}) */

import helpers from "./helpers";

Vue.use(helpers, store);

const bar = () => import("./components/uicomponents/bar.vue");
const label = () => import("./components/uicomponents/label.vue");
const button = () => import("./components/uicomponents/button.vue");
const emotlist = () => import("./components/uicomponents/emotlist.vue");
const menutabs = () => import("./components/uicomponents/menutabs.vue");
const datatable = () => import("./components/uicomponents/datatable.vue");
const datepicker = () =>
  import("./components/uicomponents/datepicker/datepicker.vue");
const headerdate = () => import("./components/uicomponents/headerdate.vue");
const tickertext = () => import("./components/uicomponents/tickertext.vue");
const rosterday = () => import("./components/uicomponents/rosterday.vue");
const timemarks = () => import("./components/uicomponents/timemarks.vue");
const listlabel = () => import("./components/uicomponents/listlabel.vue");
const menudetails = () => import("./components/menucontext/menudetails.vue");
const headerbuttonstack = () =>
  import("./components/uicomponents/headerbuttonstack.vue");
const burgermenu = () => import("./components/uicomponents/burgermenu.vue");
const employeeentry = () =>
  import("./components/uicomponents/employeeentry.vue");
const colorselection = () =>
  import("./components/uicomponents/colorselection.vue");
const employeepicture = () =>
  import("./components/uicomponents/employeepicture.vue");
const datatablefilter = () =>
  import("./components/uicomponents/datatablefilter.vue");
const datatablepaging = () =>
  import("./components/uicomponents/datatablepaging.vue");
const datatabletextfilter = () =>
  import("./components/uicomponents/datatabletextfilter.vue");
const monthlyholidayentry = () =>
  import("./components/uicomponents/monthlyholidayentry.vue");
const dateselectionheader = () =>
  import("./components/uicomponents/dateselectionheader.vue");

Vue.component("bar", bar);
Vue.component("labelc", label);
Vue.component("buttonc", button);
Vue.component("emotlist", emotlist);
Vue.component("menutabs", menutabs);
Vue.component("datatable", datatable);
Vue.component("datepicker", datepicker);
Vue.component("headerdate", headerdate);
Vue.component("tickertext", tickertext);
Vue.component("rosterday", rosterday);
Vue.component("timemarks", timemarks);
Vue.component("listlabel", listlabel);
Vue.component("menudetails", menudetails);
Vue.component("headerbuttonstack", headerbuttonstack);
Vue.component("burgermenu", burgermenu);
Vue.component("employeeentry", employeeentry);
Vue.component("colorselection", colorselection);
Vue.component("employeepicture", employeepicture);
Vue.component("datatablepaging", datatablepaging);
Vue.component("datatablefilter", datatablefilter);
Vue.component("datatabletextfilter", datatabletextfilter);
Vue.component("monthlyholidayentry", monthlyholidayentry);
Vue.component("dateselectionheader", dateselectionheader);

const loginpanel = () => import("./components/login/loginpanel.vue");
const profilepanel = () => import("./components/profile/profilepanel.vue");

Vue.component("loginpanel", loginpanel);
Vue.component("profilepanel", profilepanel);
Vue.component("landing", () => import("./views/LandingPage.vue"));
Vue.component("filemanagement", () => import("./views/FilesMain.vue"));
Vue.component("settings", () => import("./views/Company.vue"));

Vue.component("promotions", () =>
  import("./components/filecontext/FileManagement.vue")
);

Vue.component("userroles", () =>
  import("./components/settingcontext/UserRoles.vue")
);

Vue.component("sync", () => import("./components/admincontext/sync.vue"));
Vue.component("todopromo", () =>
  import("./components/admincontext/todopromo.vue")
);

import $ from "jquery";
Vue.use(require("vue-moment"));

Vue.directive("tooltip", {
  bind: function (el, binding, vnode) {
    el.addEventListener("mouseenter", function () {
      if (!binding.value) return;
      if (typeof binding.value === "string") {
        window.app.ToggleTooltip({
          toggled: true,
          header: binding.value,
        });
      } else if (
        Object.prototype.toString.call(binding.value) == "[object Function]"
      ) {
        //for generated string you have to wrap them in functions example: GetAmountWrapper() { return  () => { return view.GetAmount(date) }}
        if (binding.value()) {
          if (typeof binding.value() === "string") {
            window.app.ToggleTooltip({
              toggled: true,
              header: binding.value(),
            });
          } else {
            window.app.ToggleTooltip(binding.value());
          }
        }
      } else {
        window.app.ToggleTooltip(binding.value);
      }
    });
    el.addEventListener("mousemove", function () {
      window.app.RepositionTooltip();
    });
    el.addEventListener("DOMNodeRemoved", function () {
      window.app.ToggleTooltip({
        toggled: false,
        header: "",
        type: "",
        componentState: null,
      });
    });
    el.addEventListener("mouseleave", function () {
      window.app.ToggleTooltip({
        toggled: false,
        header: "",
        type: "",
        componentState: null,
      });
    });
  },
});

Vue.directive("header-position-lock", {
  bind: function (el, binding, vnode) {
    requestAnimationFrame(function () {
      let scrollContainer = el.parentNode;
      if (scrollContainer.parentNode.classList.contains("component-container"))
        scrollContainer = scrollContainer.parentNode;
      scrollContainer.addEventListener("scroll", function ($event) {
        el.style.setProperty(
          "margin-left",
          scrollContainer.scrollLeft + "px",
          "important"
        );
        el.style.setProperty(
          "margin-top",
          scrollContainer.scrollTop + "px",
          "important"
        );
      });
    });
  },
});

new Vue({
  store: store,
  router: router,
  render: (h) => h(App),
}).$mount("#app");
